import { useDispatch } from 'src/store';
import { actions } from 'src/store/search';

export const useSearchInputActions = () => {
  const dispatch = useDispatch();

  return {
    blurSearchInput: () => {
      dispatch(actions.blurSearchInput());
    },
    focusSearchInput: () => {
      dispatch(actions.focusSearchInput());
    },
  };
};
